import { SystemField } from "./system-field";

export class PhysicalCount extends SystemField{ 
     ref_code?:string;
     external_ref_code?:string;
     phycount_date?:string;
     status?:string;
     post_period?:string;
     reason_code_id?:string;
     total_qty?:number;
     total_cost?:number;
     warehouse_id?:string;
     sheet?:string;
     langs?:any;
}
export class PhysicalCountTranslate extends SystemField{ 
     lang_code?:string;
     physical_count_id?:string;
     description?:string;
}